"use strict";
/*
 * Created on 10 04 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Jaroslav Sevcik
 */


var CategoryCleaningStateConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(CategoryCleaningStateConverter, _DataObjectConverter_);

  function CategoryCleaningStateConverter() {
    _classCallCheck(this, CategoryCleaningStateConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(CategoryCleaningStateConverter).apply(this, arguments));
  }

  return CategoryCleaningStateConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.CategoryCleaningStateConverter = CategoryCleaningStateConverter;